import request from '@/utils/request';
/* 列表 */
export function orderList(data) {
  return request({
    url: '/order/queryOrderPageList',
    method: 'POST',
    data
  });
}
/* 获取订单信息表列表待支付、代发货、待核销总数据条数 */
export function queryOrderPageCount(data) {
  return request({
    url: '/order/queryOrderPageCount',
    method: 'POST',
    data
  });
}
/* 订单信息表明细 */
export function fetchOrderDetailById(data) {
  return request({
    url: '/order/fetchOrderDetailById',
    method: 'POST',
    data
  });
}
/* 发货操作 */
export function saveGoodsOrderSend(data) {
  return request({
    url: '/order/webOrderShipment',
    method: 'POST',
    data
  });
}
/* 核销操作 */
export function writeOutOrder(data) {
  return request({
    url: '/order/writeOutOrder',
    method: 'POST',
    data
  });
}
/* 订单变更配送方式 */
export function changeOrderDeliveryType(data) {
  return request({
    url: '/order/changeOrderDeliveryType',
    method: 'POST',
    data
  });
}
/* 商品订单中购买的商品信息 */
export function queryOrderGoodsInfoByOrderId(data) {
  return request({
    url: '/goods/order/send/queryOrderGoodsInfoByOrderId',
    method: 'POST',
    data
  });
}
/* 获取订单物流信息 */
export function fetchOrderLogisticsById(data) {
  return request({
    url: '/order/fetchOrderLogisticsById',
    method: 'POST',
    data
  });
}
// 订单导出Excel
export function orderExportExcel(data) {
  return request({
    url: '/order/exportOrderListToExcel',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}
// 硒游记-获取订单信息表列表待支付、代发货、待核销总数据条数
export function querySeleniumJourneyOrderCount(data) {
  return request({
    url: '/selenium/journey/order/querySeleniumJourneyOrderCount',
    method: 'POST',
    data
  });
}
// 硒游记-获取订单信息表列表
export function querySeleniumJourneyOrderPageList(data) {
  return request({
    url: '/selenium/journey/order/querySeleniumJourneyOrderPageList',
    method: 'POST',
    data
  });
}
// 硒游记-订单导出Excel
export function orderBasesExportExcel(data) {
  return request({
    url: '/selenium/journey/order/exportSeleniumJourneyOrderListToExcel',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}
// 订单录入-搜索门店用户
export function searchUserShopList(data) {
  return request({
    url: '/app/user/shop/searchUserShopList',
    method: 'POST',
    data
  });
}
// 订单录入-获取用户待使用优惠券列表
export function queryUserCouponReceiveLogList(data) {
  return request({
    url: '/coupon/receive/log/queryUserCouponReceiveLogList',
    method: 'POST',
    data
  });
}
// 订单录入-获取订单录入运费
export function getOrderInputMoveMoney(data) {
  return request({
    url: '/goods/move/template/getOrderInputMoveMoney',
    method: 'POST',
    data
  });
}
// 订单录入-获取门店商品可选择数据分页列表
export function querySelectShopGoodsPageList(data) {
  return request({
    url: '/shop/goods/querySelectShopGoodsPageList',
    method: 'POST',
    data
  });
}
// 订单录入-获取用户地址列表
export function queryUserAddressList(data) {
  return request({
    url: '/user/address/queryUserAddressList',
    method: 'POST',
    data
  });
}
// 订单录入-确认录入
export function submitOrderInput(data) {
  return request({
    url: '/shop/goods/submitOrderInput',
    method: 'POST',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/order.js